module.exports = __webpack_public_path__ + "static/img/fr.d26918c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fr.svg
// module id = w3lL
// module chunks = 4